<template>
    <div class="d-flex align-center justify-center full-page-container h-100">
        <div style="width: 100vw; max-width: 500px">
            <div class="d-flex w-100 justify-center py-5 rounded-lg shadow-xl bg-main-dark">
                <img src="/images/logo.svg" class="justify-center" alt="Logo" height="100" />
            </div>
            <div class="w-100 pa-10 rounded-lg shadow-xl bg-white">
                <slot></slot>
            </div>
        </div>
    </div>
</template>
